module.exports = __webpack_public_path__ + "img/CivsListBG_OLD.e2e29194.webp";